export const BUTTON_CLICK = 'buttonClick';
export const BUTTON_CLICK_BACK = 'backButtonClick';
